import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

class toc {
  constructor(context) {

    window.addEventListener('activate.bs.scrollspy', function (e) {
      const link = context.querySelector('#toc .nav .active');
      if (link) {
        gsap.to(context.querySelector('#toc .nav'), { duration: 1, scrollTo: { x: link.offsetLeft } });
      }
    });
  }
};

export default toc;